// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OperationscatalogSeverity } from './OperationscatalogSeverity';
import {
  OperationscatalogSeverityFromJSON,
  OperationscatalogSeverityFromJSONTyped,
  OperationscatalogSeverityToJSON,
  OperationscatalogSeverityToJSONTyped,
} from './OperationscatalogSeverity';
import type { OperationscatalogField } from './OperationscatalogField';
import {
  OperationscatalogFieldFromJSON,
  OperationscatalogFieldFromJSONTyped,
  OperationscatalogFieldToJSON,
  OperationscatalogFieldToJSONTyped,
} from './OperationscatalogField';
import type { OperationscatalogExecutionKind } from './OperationscatalogExecutionKind';
import {
  OperationscatalogExecutionKindFromJSON,
  OperationscatalogExecutionKindFromJSONTyped,
  OperationscatalogExecutionKindToJSON,
  OperationscatalogExecutionKindToJSONTyped,
} from './OperationscatalogExecutionKind';
import type { OperationscatalogOperationType } from './OperationscatalogOperationType';
import {
  OperationscatalogOperationTypeFromJSON,
  OperationscatalogOperationTypeFromJSONTyped,
  OperationscatalogOperationTypeToJSON,
  OperationscatalogOperationTypeToJSONTyped,
} from './OperationscatalogOperationType';

/**
 *
 * @export
 * @interface OperationscatalogOperation
 */
export interface OperationscatalogOperation {
  /**
   * Plain-text paragraphs for confirmation views, rendered in order.
   * @type {Array<string>}
   * @memberof OperationscatalogOperation
   */
  descriptions?: Array<string>;
  /**
   * URL to the operation's documentation. Empty when none is declared.
   * @type {string}
   * @memberof OperationscatalogOperation
   */
  docsLink?: string;
  /**
   * Kinds lists how the operation can be executed. A nil/empty slice means
   * ArgoWorkflow; use ExecutionKinds to read this field.
   * @type {Array<OperationscatalogExecutionKind>}
   * @memberof OperationscatalogOperation
   */
  executionKinds?: Array<OperationscatalogExecutionKind>;
  /**
   * Additional user inputs. Target and context parameters are not included.
   * @type {Array<OperationscatalogField>}
   * @memberof OperationscatalogOperation
   */
  fields?: Array<OperationscatalogField>;
  /**
   * Logical operation name.
   * @type {string}
   * @memberof OperationscatalogOperation
   */
  name?: string;
  /**
   * Team that owns the operation, for example sre.
   * @type {string}
   * @memberof OperationscatalogOperation
   */
  owner?: string;
  /**
   * Caller parameters, including common context, target values, and additional fields.
   * @type {Array<string>}
   * @memberof OperationscatalogOperation
   */
  parameters?: Array<string>;
  /**
   * True when the workflow writes a GCS console URL to workflow_output on success.
   * @type {boolean}
   * @memberof OperationscatalogOperation
   */
  producesLink?: boolean;
  /**
   * Risk level used by clients when presenting the operation.
   * @type {OperationscatalogSeverity}
   * @memberof OperationscatalogOperation
   */
  severity?: OperationscatalogSeverity;
  /**
   * One-line operation name for list views.
   * @type {string}
   * @memberof OperationscatalogOperation
   */
  summary?: string;
  /**
   * Kind of operation: database-operation, server-operation, or neo4j-cluster-operation.
   * @type {OperationscatalogOperationType}
   * @memberof OperationscatalogOperation
   */
  type?: OperationscatalogOperationType;
  /**
   * Warning messages rendered as separate admonitions.
   * @type {Array<string>}
   * @memberof OperationscatalogOperation
   */
  warnings?: Array<string>;
}

/**
 * Check if a given object implements the OperationscatalogOperation interface.
 */
export function instanceOfOperationscatalogOperation(
  value: object,
): value is OperationscatalogOperation {
  return true;
}

export function OperationscatalogOperationFromJSON(
  json: any,
): OperationscatalogOperation {
  return OperationscatalogOperationFromJSONTyped(json, false);
}

export function OperationscatalogOperationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogOperation {
  if (json == null) {
    return json;
  }
  return {
    descriptions:
      json['descriptions'] == null ? undefined : json['descriptions'],
    docsLink: json['docs_link'] == null ? undefined : json['docs_link'],
    executionKinds:
      json['execution_kinds'] == null
        ? undefined
        : (json['execution_kinds'] as Array<any>).map(
            OperationscatalogExecutionKindFromJSON,
          ),
    fields:
      json['fields'] == null
        ? undefined
        : (json['fields'] as Array<any>).map(OperationscatalogFieldFromJSON),
    name: json['name'] == null ? undefined : json['name'],
    owner: json['owner'] == null ? undefined : json['owner'],
    parameters: json['parameters'] == null ? undefined : json['parameters'],
    producesLink:
      json['produces_link'] == null ? undefined : json['produces_link'],
    severity:
      json['severity'] == null
        ? undefined
        : OperationscatalogSeverityFromJSON(json['severity']),
    summary: json['summary'] == null ? undefined : json['summary'],
    type:
      json['type'] == null
        ? undefined
        : OperationscatalogOperationTypeFromJSON(json['type']),
    warnings: json['warnings'] == null ? undefined : json['warnings'],
  };
}

export function OperationscatalogOperationToJSON(
  json: any,
): OperationscatalogOperation {
  return OperationscatalogOperationToJSONTyped(json, false);
}

export function OperationscatalogOperationToJSONTyped(
  value?: OperationscatalogOperation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    descriptions: value['descriptions'],
    docs_link: value['docsLink'],
    execution_kinds:
      value['executionKinds'] == null
        ? undefined
        : (value['executionKinds'] as Array<any>).map(
            OperationscatalogExecutionKindToJSON,
          ),
    fields:
      value['fields'] == null
        ? undefined
        : (value['fields'] as Array<any>).map(OperationscatalogFieldToJSON),
    name: value['name'],
    owner: value['owner'],
    parameters: value['parameters'],
    produces_link: value['producesLink'],
    severity: OperationscatalogSeverityToJSON(value['severity']),
    summary: value['summary'],
    type: OperationscatalogOperationTypeToJSON(value['type']),
    warnings: value['warnings'],
  };
}
